var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("header-kravicka", {
        attrs: { profil: _vm.profil },
        on: { updateProfil: _vm.emitUpdateProfil }
      }),
      _vm._v(" "),
      _c("main", { staticClass: "puzzleMain" }, [
        _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "row justify-content-center" }, [
            _c("div", { staticClass: "col-md-12 col-xl-10" }, [
              _c("div", { staticClass: "o-pexesoGame --overflowHelp" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "m-pexesoGame__header d-flex align-items-center justify-content-between"
                  },
                  [
                    _c("h3", { staticClass: "mb-0" }, [
                      _vm._v("Poskladaj obrázok kravičky "),
                      _c(
                        "span",
                        {
                          staticClass: "--napoveda",
                          on: {
                            click: function($event) {
                              return _vm.$bvModal.show("modalPuzzleNahlad")
                            }
                          }
                        },
                        [
                          _c("span", { staticClass: "icon --questionMark" }),
                          _vm._v("Pomôcka")
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "a-pexesoGame__stats" }, [
                      _c("span", { staticClass: "pexesoGame__time" }, [
                        _vm._v("Čas:"),
                        _c("span", [_vm._v(_vm._s(_vm.stopWatch))])
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "pexesoGame__moves" }, [
                        _vm._v("Ťahov:"),
                        _c("span", [_vm._v(_vm._s(_vm.steps))])
                      ])
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "board-outer" }, [
                  _c(
                    "div",
                    { staticClass: "board" },
                    [
                      _vm._l(_vm.tiles, function(tile) {
                        return [
                          _c(
                            "div",
                            {
                              staticClass: "tile",
                              style: {
                                top: tile.row * _vm.multiplier + "%",
                                left: tile.col * _vm.multiplier + "%"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.tileClick(tile)
                                }
                              }
                            },
                            [
                              _c("img", {
                                staticClass: "tile",
                                style: {
                                  width: 910 / _vm.cols + "px",
                                  height: 590 / _vm.rows + "px"
                                },
                                attrs: {
                                  src: "assets/img/puzzle/" + tile.imageSrc,
                                  alt: ""
                                }
                              })
                            ]
                          )
                        ]
                      })
                    ],
                    2
                  )
                ])
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pexesoFooter --left" },
        [
          _c(
            "button",
            {
              staticClass: "btn --primary restartGame",
              on: { click: _vm.restartGame }
            },
            [_c("span", { staticClass: "icon" })]
          ),
          _vm._v(" "),
          _c(
            "router-link",
            {
              staticClass: "btn --secondary emdGame",
              attrs: {
                to: {
                  name: "slider-landing",
                  params: { kravicka_id: _vm.$route.params.kravicka_id }
                }
              }
            },
            [_vm._v("\n            Ukončiť hru\n        ")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pexesoFooter --right d-none d-md-block" },
        [
          _c(
            "router-link",
            {
              staticClass: "btn --primary closeGame",
              attrs: {
                to: {
                  name: "kravicka",
                  params: { kravicka_id: _vm.$route.params.kravicka_id }
                }
              }
            },
            [_c("span", { staticClass: "icon" })]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "modalPuzzleNahlad",
          staticClass: "modal fade",
          attrs: {
            id: "modalPuzzleNahlad",
            "hide-footer": "",
            "hide-header": "",
            centered: "",
            tabindex: "-1",
            role: "dialog",
            "aria-labelledby": "modalPuzzleNahladTitle",
            "aria-hidden": "true"
          }
        },
        [
          _c(
            "b-button",
            {
              staticClass: "m-modalInfo__close",
              attrs: { block: "" },
              on: {
                click: function($event) {
                  return _vm.$bvModal.hide("modalPuzzleNahlad")
                }
              }
            },
            [_c("span", { staticClass: "icon" })]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "modal-body", staticStyle: { padding: "0" } },
            [
              _c("div", { staticClass: "text-center" }, [
                _vm.aktualnyMotiv
                  ? _c("img", {
                      staticClass: "img-fluid",
                      attrs: { src: "assets/img/" + _vm.aktualnyMotiv + ".jpg" }
                    })
                  : _vm._e()
              ])
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "modalVyhratePexeso",
          staticClass: "modal fade",
          attrs: {
            id: "modalVyhratePexeso",
            "hide-footer": "",
            "hide-header": "",
            centered: "",
            tabindex: "-1",
            role: "dialog",
            "aria-labelledby": "modalVyhratePexesoTitle",
            "aria-hidden": "true"
          }
        },
        [
          _c(
            "b-button",
            {
              staticClass: "m-modalInfo__close",
              attrs: { block: "" },
              on: {
                click: function($event) {
                  return _vm.$bvModal.hide("modalVyhratePexeso")
                }
              }
            },
            [_c("span", { staticClass: "icon" })]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "modal-body o-modalInfo" }, [
            _c(
              "div",
              { staticClass: "m-modalLostPassword__content text-center" },
              [
                _c("img", {
                  staticClass: "img-fluid mb-3",
                  attrs: { src: "assets/img/winningPexeso.png", alt: "" }
                }),
                _vm._v(" "),
                _c(
                  "h2",
                  { staticClass: "m-modalWinningPexeso__name text-center" },
                  [_vm._v("Gratulujeme!")]
                ),
                _vm._v(" "),
                _c(
                  "p",
                  {
                    staticClass: "text-center m-modalWinningPexeso__text mb-4"
                  },
                  [
                    _vm._v(
                      "\n                    Úspešne si dokončil hru Skladanie obrázka."
                    ),
                    _c("br"),
                    _vm._v(" Tvoj čas bol "),
                    _c("span", [_vm._v(_vm._s(_vm.stopWatch))]),
                    _vm._v(" a zvládol si to na "),
                    _c("span", [_vm._v(_vm._s(_vm.steps) + " ťahov")]),
                    _vm._v(".\n                ")
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "text-center" },
                  [
                    _c(
                      "router-link",
                      {
                        staticClass: "btn --primary",
                        attrs: {
                          to: {
                            name: "kravicka",
                            params: {
                              kravicka_id: _vm.$route.params.kravicka_id
                            }
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n                        Ukončiť hru\n                    "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "router-link",
                      {
                        staticClass: "btn --secondary --trophy",
                        attrs: {
                          to: {
                            name: "slider-leaders",
                            params: {
                              kravicka_id: _vm.$route.params.kravicka_id
                            }
                          }
                        }
                      },
                      [
                        _c("span", { staticClass: "icon" }),
                        _vm._v("Tabuľka najlepších\n                    ")
                      ]
                    )
                  ],
                  1
                )
              ]
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }